/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Cancel_Subscription_BtnInputs */

const en_dialog_cancel_subscription_btn = /** @type {(inputs: Dialog_Cancel_Subscription_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel subscription`)
};

const es_dialog_cancel_subscription_btn = /** @type {(inputs: Dialog_Cancel_Subscription_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar suscripción`)
};

/**
* | output |
* | --- |
* | "Cancel subscription" |
*
* @param {Dialog_Cancel_Subscription_BtnInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_cancel_subscription_btn = /** @type {((inputs?: Dialog_Cancel_Subscription_BtnInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Cancel_Subscription_BtnInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_cancel_subscription_btn(inputs)
	return en_dialog_cancel_subscription_btn(inputs)
});